import React, { useCallback, useEffect, useState } from "react";
import { api, formatApiError } from "../lib/api";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Upload } from "lucide-react";
import { toast } from "sonner";

export default function ImportHomologation() {
  const [batches, setBatches] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    const { data } = await api.get("/imports/batches");
    setBatches(data || []);
  }, []);

  useEffect(() => { load(); }, [load]);

  const onUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    setLoading(true);
    try {
      await api.post("/imports/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Importação enviada para homologação");
      load();
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail) || "Falha ao importar arquivo");
    } finally {
      setLoading(false);
      e.target.value = "";
    }
  };

  return (
    <div className="space-y-6" data-testid="import-homologation-page">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <h1 className="font-display font-bold text-2xl">Homologação de importações</h1>
          <p className="text-sm text-muted-foreground">CSV, Excel, XML, PDF, TXT</p>
        </div>
        <label className="cursor-pointer">
          <input type="file" accept=".csv,.xlsx,.xls,.xml,.pdf,.txt,.json" className="hidden" onChange={onUpload} data-testid="import-upload-input" />
          <Button asChild disabled={loading}>
            <span><Upload size={16} className="mr-2 inline" />Importar arquivo</span>
          </Button>
        </label>
      </div>

      <div className="grid gap-3">
        {batches.map((b) => (
          <Card key={b.id} className="p-4 flex items-center justify-between">
            <div>
              <div className="font-semibold">{b.source_name || b.id.slice(0, 8)}</div>
              <div className="text-xs text-muted-foreground">{b.source_format?.toUpperCase()} · {b.total_rows} linhas · {b.created_at?.slice(0, 10)}</div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
